import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import HTMLDisplay from "../../../utils/HTMLDisplay";
import "../../../assets/css/LatestNewSection.css";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

function formatDate(dateStr) {
  if (!dateStr) {
    return { month: "", day: "", year: "" };
  }

  const date = new Date(dateStr);

  if (Number.isNaN(date.getTime())) {
    return { month: "", day: "", year: "" };
  }

  return {
    month: date.toLocaleString("en", { month: "short" }).toUpperCase(),
    day: date.getDate(),
    year: date.getFullYear(),
  };
}

function hasImage(passport) {
  return (
    typeof passport === "string" &&
    passport.trim() !== "" &&
    passport !== "undefined" &&
    passport !== "null"
  );
}

function NewsDate({ date, compact = false }) {
  const { month, day, year } = formatDate(date);

  if (!month) return null;

  return (
    <div
      className={`fmw-news-date${compact ? " fmw-news-date-compact" : ""}`}
      aria-label={`${month} ${day}, ${year}`}
    >
      <span>{month}</span>
      <strong>{day}</strong>
      <span>{year}</span>
    </div>
  );
}

function LatestNewSection({ datacontent, initialPagination, id }) {
  const [newsList, setNewsList] = useState(datacontent || []);
  const [selectedNews, setSelectedNews] = useState(datacontent?.[0] || null);
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState(
    initialPagination || {
      current_page: 1,
      last_page: 1,
    },
  );
  const [loading, setLoading] = useState(false);
  const [fetchError, setFetchError] = useState(false);

  useEffect(() => {
    setNewsList(datacontent || []);
    setSelectedNews(datacontent?.[0] || null);
    setPage(1);

    if (initialPagination) {
      setPagination(initialPagination);
    }
  }, [datacontent, initialPagination]);

  useEffect(() => {
    let active = true;

    const fetchNews = async () => {
      setLoading(true);
      setFetchError(false);

      try {
        const response = await axios.get(
          `${BASE_URL}posdata?pageName[eq]=${encodeURIComponent(
            id,
          )}&columes[eq]=title_show_echo_01zz&ministry[eq]=0&status02[eq]=publish&status[eq]=Public&visibility[eq]=Public&page=${page}&per_page=3`,
        );

        if (!active) return;

        const allData = response?.data?.allData || [];

        setNewsList(allData);
        setSelectedNews((current) => {
          if (current && allData.some((item) => item.id === current.id)) {
            return allData.find((item) => item.id === current.id);
          }

          return allData[0] || null;
        });

        setPagination(
          response?.data?.pagination || {
            current_page: page,
            last_page: 1,
          },
        );
      } catch (error) {
        if (active) {
          console.error("Unable to fetch latest news:", error);
          setFetchError(true);
        }
      } finally {
        if (active) setLoading(false);
      }
    };

    fetchNews();

    return () => {
      active = false;
    };
  }, [page, id]);

  const currentPage = Number(pagination?.current_page || page);
  const lastPage = Number(pagination?.last_page || 1);

  const changePage = (nextPage) => {
    const safePage = Math.min(Math.max(nextPage, 1), lastPage);

    if (safePage !== page) {
      setPage(safePage);
    }
  };
  console.log("###333", newsList, selectedNews);
  return (
    <section className="fmw-latest-news-section">
      <div className="container">
        <div className="fmw-news-section-heading">
          <div>
            <span className="fmw-news-eyebrow">
              INFRASTRUCTURE · CONNECTIVITY · DEVELOPMENT
            </span>
            <h2>
              Latest <span>News</span>
            </h2>
            {/* <p>
              The latest updates, announcements and stories from the
              Federal Ministry of Works.
            </p> */}
          </div>

          <Link to="/read/title_show_echo_01zz" className="fmw-news-view-all">
            View All News <span aria-hidden="true">→</span>
          </Link>
        </div>

        {loading && (
          <div className="fmw-news-status" role="status">
            <span className="fmw-news-spinner" />
            Loading latest news...
          </div>
        )}

        {!loading && fetchError && newsList.length === 0 && (
          <div className="fmw-news-empty">
            <i className="fa-regular fa-newspaper" aria-hidden="true" />
            <h3>News is temporarily unavailable</h3>
            <p>Please try again shortly.</p>
            <button
              type="button"
              className="fmw-news-retry"
              onClick={() => setPage((current) => current)}
            >
              Please refresh the page
            </button>
          </div>
        )}

        {!loading && !fetchError && !selectedNews && (
          <div className="fmw-news-empty">
            <i className="fa-regular fa-newspaper" aria-hidden="true" />
            <h3>No news available at the moment</h3>
            <p>Please check back for the latest ministry updates.</p>
          </div>
        )}

        {selectedNews && (
          <div className="fmw-news-layout">
            {/* Featured article */}
            <article className="fmw-featured-news">
              <Link
                to={`/read/${selectedNews.id}`}
                className="fmw-featured-news-image"
                aria-label={`Read ${selectedNews.title || "featured news"}`}
              >
                {hasImage(selectedNews.passport) ? (
                  <img
                    src={`${BACKEND_URL}upload/${selectedNews.passport}`}
                    alt={selectedNews.title || "Featured ministry news"}
                    loading="lazy"
                    decoding="async"
                  />
                ) : (
                  <div className="fmw-news-image-placeholder">
                    <i className="fa-regular fa-newspaper" aria-hidden="true" />
                    <span>FMW News</span>
                  </div>
                )}

                <NewsDate date={selectedNews.daterqw} />

                <span className="fmw-featured-label">FEATURED STORY</span>
              </Link>

              <div className="fmw-featured-news-content">
                <span className="fmw-news-category">MINISTRY NEWS</span>

                <h3>
                  <Link to={`/read/${selectedNews.id}`}>
                    <HTMLDisplay
                      html={selectedNews.story01}
                      textNo={18}
                      type="title"
                    />
                  </Link>
                </h3>

                <p className="fmw-featured-summary">
                  <HTMLDisplay
                    html={selectedNews.story01}
                    textNo={30}
                    type="body"
                  />
                </p>

                <Link
                  to={`/read/${selectedNews.id}`}
                  className="fmw-news-read-more"
                >
                  Read Full Story <span aria-hidden="true">→</span>
                </Link>
              </div>
            </article>

            {/* More stories */}
            <aside className="fmw-news-sidebar">
              <div className="fmw-news-sidebar-heading">
                <div>
                  <span>KEEP INFORMED</span>
                  <h3>More Stories</h3>
                </div>
                <span className="fmw-news-story-count">{newsList.length}</span>
              </div>

              <div className="fmw-news-story-list">
                {newsList.map((item, index) => {
                  const isSelected = item.id === selectedNews.id;

                  return (
                    <article
                      key={item.id || index}
                      className={`fmw-news-story${
                        isSelected ? " is-selected" : ""
                      }`}
                    >
                      <button
                        type="button"
                        className="fmw-news-story-select"
                        onClick={() => setSelectedNews(item)}
                        aria-pressed={isSelected}
                        aria-label={`Feature story: ${
                          item.title || "ministry news"
                        }`}
                      >
                        <span className="fmw-news-story-thumb">
                          {hasImage(item.passport) ? (
                            <img
                              src={`${BACKEND_URL}upload/${item.passport}`}
                              alt=""
                              loading="lazy"
                              decoding="async"
                            />
                          ) : (
                            <span className="fmw-news-thumb-placeholder">
                              <i
                                className="fa-regular fa-newspaper"
                                aria-hidden="true"
                              />
                            </span>
                          )}

                          <NewsDate date={item.daterqw} compact />
                        </span>

                        <span className="fmw-news-story-info">
                          <span className="fmw-news-story-category">
                            {isSelected ? "NOW FEATURED" : "LATEST UPDATE"}
                          </span>

                          <span className="fmw-news-story-title">
                            <HTMLDisplay
                              html={item.story01}
                              textNo={13}
                              type="title"
                            />
                          </span>

                          <span className="fmw-news-story-action">
                            {isSelected ? "Currently featured" : "View story"}
                            <span aria-hidden="true"> →</span>
                          </span>
                        </span>
                      </button>
                    </article>
                  );
                })}
              </div>

              {/* Pagination */}
              <nav className="fmw-news-pagination" aria-label="News pages">
                <button
                  type="button"
                  onClick={() => changePage(1)}
                  disabled={currentPage <= 1 || loading}
                  aria-label="First page"
                >
                  «
                </button>

                <button
                  type="button"
                  onClick={() => changePage(currentPage - 1)}
                  disabled={currentPage <= 1 || loading}
                  aria-label="Previous page"
                >
                  ‹
                </button>

                <span>
                  Page <strong>{currentPage}</strong> of {lastPage}
                </span>

                <button
                  type="button"
                  onClick={() => changePage(currentPage + 1)}
                  disabled={currentPage >= lastPage || loading}
                  aria-label="Next page"
                >
                  ›
                </button>

                <button
                  type="button"
                  onClick={() => changePage(lastPage)}
                  disabled={currentPage >= lastPage || loading}
                  aria-label="Last page"
                >
                  »
                </button>
              </nav>
            </aside>
          </div>
        )}
      </div>
    </section>
  );
}

export default React.memo(LatestNewSection);
